/* eslint-disable react/prop-types */
import { useState, useEffect, useMemo } from "react";
import PropertiesView from "pages/Search/components/PropertiesView";
import { Stack, Box, Grid, Pagination, NativeSelect } from "@mui/material";
import MKTypography from "components/MKTypography";
import { useNavigate } from "react-router-dom";
import requests from "./propertiesRequests";

// function that process request from searchproperty
function PropertyService({
  type = "all",
  term = "",
  zone = [],
  flatType = [],
  businessActivity = [],
  propertyType = [],
  suburb = [],
}) {
  // READ URL PARAMETERS
  function useQuery() {
    return useMemo(() => new URLSearchParams(window.location.search));
  }
  const query = useQuery();
  const history = useNavigate();
  const addQuery = (key, value) => {
    const { pathname } = window.location;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    history({
      pathname,
      search: unescape(searchParams.toString()),
    });
    window.location.reload();
  };
  /// ///////////////////////////////////////////////////////
  const [page, setPage] = useState(query.get("p") ? parseInt(query.get("p"), 10) : 1);
  const [perPage, setContentPerPage] = useState(
    query.get("pp") ? parseInt(query.get("pp"), 10) : 10
  );
  const [results, setResults] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState();
  const [pageCount, setPageCount] = useState();

  // read url API, call propertiesRequests
  const APIResult = (request) => {
    useEffect(() => {
      fetch(request)
        .then(async (response) => response.json())
        .then(async (body) => {
          setResults(await [...body.results]);
          setCount(body.count);
        })
        .catch((err) => {
          setError(err.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }, [request]);
    return [results, error];
  };

  // content per page
  const perpage = (event) => {
    setContentPerPage(event.target.value);
    addQuery("pp", event.target.value);
    setPage(1);
    addQuery("p", 1);
  };
  // pagination onPageChange, set value page
  const handlePageChange = (e, value) => {
    setPage(value);
    addQuery("p", value);
  };

  /// /////////////////// PAGE COUNT ////////////////////////////////////
  useEffect(() => {
    setPageCount(Math.ceil(count / perPage));
  });
  /// /////////////////////////////////////////////////////////////////

  // getAll properties
  const getAll = () => {
    const [request] = requests.getProperties({ page, perPage });
    return APIResult(request);
  };
  // get properties by name
  const getbyName = () => {
    const [request] = requests.getPropertyByName({
      page,
      perPage,
      term,
      zone,
      flatType,
      businessActivity,
      propertyType,
      suburb,
    });
    return APIResult(request);
  };

  // evaluate search type
  const fetchProperties = (action) => {
    if (action === "all") {
      return getAll();
    }
    return getbyName();
  };
  const [propertiesData] = fetchProperties({ type }); // return data from API

  return (
    <>
      <PropertiesView properties={propertiesData} load={loading} />
      <Grid container spacing={2}>
        <Grid item xs={5}>
          <MKTypography variant="body2" color="text" pl={1} my={1} size="medium">
            Resultados por página: &nbsp;
            <NativeSelect value={perPage} onChange={perpage} variant="filled">
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={25}>25</option>
            </NativeSelect>
          </MKTypography>
        </Grid>
        <Grid item xs={7}>
          <Box m={2}>
            <Stack direction="row" justifyContent="end">
              <Pagination
                size="medium"
                xs={12}
                lg={7}
                onChange={handlePageChange}
                count={pageCount}
                itemsPerPage={perPage}
                variant="outlined"
                color="secondary"
                showFirstButton
                showLastButton
                defaultPage={page}
              />
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

export default PropertyService;
